import React, { createContext, useContext, useState, useEffect } from 'react'
import Service from '../service'

const FlowStageContext = createContext();

const DEFAULT_FLOW_STAGE = {
  flowStageId: null,
  flowStageTitle: null
}

const FlowStageContextProvider = ({ children }) => {
  const [flowStageDetails, setFlowStageDetails] = useState(DEFAULT_FLOW_STAGE)

  return (
    <FlowStageContext.Provider value ={{
      flowStageDetails, setFlowStageDetails
    }}>
      {children}
    </FlowStageContext.Provider>
  )
}

const useFlowStage = () => useContext(FlowStageContext)

export { useFlowStage }
export default FlowStageContextProvider;